import React, { useContext, useEffect } from 'react';
import { lazy } from "react";
import Footer from '../../../components/Footer';
import Header from '../../../components/Header';
import Container from "../../Container";
import { CancelButton } from '../../Button/CancelButton';
import { SubmitButton } from '../../Button/SubmitButton';
import Grid from "@material-ui/core/Grid";
import { InnerPage, GridSkin, ContainerStyle01, ButtonDiv, ConfirmMsg, ConfirmationMsg1, ConfirmationMsg, HeadingContent, PageHeadingInner } from './styles'
import { useHistory } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { SvgIcon } from '../../SvgIcon';
import { LangContext } from '../../../context/UserContext';
import { Styles } from "../../../styles/styles";
import FallBackCompo from './FallBackCompo';

interface FallBackUIProps {
  t?: any
}

const FallBackUI = (props: FallBackUIProps) => {
  const history = useHistory();
  const languageCheck: any = useContext(LangContext);

  return (
    <>
    <Styles />
    <Header />
      <HeadingContent>
        <Container>
          <PageHeadingInner>
            <h2>{props.t("LOG_ONLINE_HEADNG01")}</h2>
          </PageHeadingInner>
        </Container>
      </HeadingContent>
      <FallBackCompo/>
      <Footer/>
    </>
  );
};

export default withTranslation()(FallBackUI);
